var $d7a4f27e0816aca3$exports = {};
/**
 * Initierar och lägger till eventlyssnare på knappen
 * När användaren klickar på knappen navigeras de till new-word.html sidan
 * @returns {void}
 */ function $d7a4f27e0816aca3$var$initBeginButton() {
    const beginButton = document.getElementById('begin-button');
    if (beginButton) beginButton.addEventListener('click', ()=>{
        window.location.href = './new-word.html';
    });
}
$d7a4f27e0816aca3$var$initBeginButton();


//# sourceMappingURL=vocabulary.a83257e6.js.map
